<template>
  <div class="usagemonth-site-list">
    <!-- 过滤 -->
    <div class="table-list">
      <div class="header">
        <div class="search-content">
          <el-form :inline="true" @submit.native.prevent>
            <!-- <el-form-item style="float: right; margin-right: 0">
              <custom-column ref="column"></custom-column>
            </el-form-item> -->

            <el-form-item style="float: right" v-if="funcView.usagemonth_site_export">
              <el-button class="custom-btn" icon="icon icon-export-excel left-icon" type="info" round
                @click="exportRecord">{{ $t('com_export') }}</el-button>
            </el-form-item>
             <el-form-item style="float: right">
              <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
            </el-form-item>
            <el-form-item style="float: right;">
              <el-date-picker
                v-model="reportMonthTime"
                type="monthrange"
                range-separator="—"
                :format="$getElFormat('yyyy-MM', true)"
                value-format="yyyy-MM"
                align="right"
                placeholder=""
                :picker-options="pickerOptionsMonth"
                :clearable="false"
                @change="onPageChange({ page: 1 })"
                :start-placeholder="$t('us_list_kai_shi_yue')"
                :end-placeholder="$t('us_list_jie_shu_yue')"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 过滤 -->
      <div class="query-filter" style="margin-top: 24px; width: 100%; padding: 0" >
        <div class="params-form" v-show="isFilter">
          <el-row :gutter="23">
            <el-col :span="8" v-if="isCoJv && showSubsidiary">
              <div class="item">
                <div class="label">{{ $t('us_list_gsmc') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.customerName" @input="onPageChange({ page: 1 })" clearable  :placeholder="$t('com_please_input')"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{`${$t('us_list_xmqymc')}`}}</div>
                <div class="value">
                  <el-input v-model="formSearch.search" @input="onPageChange({ page: 1 })" clearable
                    :placeholder="$t('com_please_input')"></el-input>
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="8">
              <div class="item select-date">
                <div class="label">时间</div>
                <div class="value">
                  <el-date-picker
                    v-model="reportMonthTime"
                    type="monthrange"
                    range-separator="—"
                    :format="$getElFormat('yyyy-MM', true)"
                    value-format="yyyy-MM"
                    align="right"
                    placeholder=""
                    :picker-options="pickerOptionsMonth"
                    :clearable="false"
                    @change="onPageChange({ page: 1 })"
                    start-placeholder="开始月"
                    end-placeholder="结束月"
                  ></el-date-picker>
                </div>
              </div>
            </el-col> -->
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('us_list_suo_shu_bu_men') }}</div>
                <div class="value">
                  <custom-select
                    url="DepartmentTree"
                    v-model="formSearch.departmentId"
                    :model="formSearch"
                    :props="{ label: 'bizName', value: 'bizId',checkStrictly: true,map: { bizName: 'departmentName' } }"
                    :params="{ isCountDevice:1 }"
                    :placeholder="$t('com_please_select')"
                    width="100%"
                    ref="tag"
                    type="tree"
                    filterable
                    :dataFilter="departmentTreeFilter"
                    @treeValChange="onPageChange({ page: 1 })"
                    @treeValChangeLabel="onDepartmentLabel"
                    @getList="onDepartmentList"
                    :clearable="false"
                  ></custom-select>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('us_list_shai_xuan_xiang') }}：</div>
          <div class="values">
            <el-tag v-if="formSearch.customerName" closable @close="
              formSearch.customerName = '';
              onPageChange({ page: 1 });
            ">
              {{ formSearch.customerName }}
            </el-tag>
            <el-tag v-if="formSearch.search" closable @close="
              formSearch.search = '';
              onPageChange({ page: 1 });
            ">
              {{ formSearch.search }}
            </el-tag>
            <el-tag
              v-if="formSearch.departmentId"
              closable
              @close="
                formSearch.departmentId = '';
                formSearch.departmentName = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.departmentName }}
            </el-tag>
            <span class="clear" @click="onClear">{{ $t('com_clear') }}</span>
          </div>
        </div>
      </div>
      <div class="table-bd">
        <el-table :data="tableList" height="100%" :index="true" @sort="sortChange" @column="setColumn" @filter="filterChange">
          <el-table-column
            v-for="(item, index) in tableColumn"
              :key="index"
              :index="index"
              :prop="item.columnCode"
              :label="item.columnName"
              :width="item.width"
              :formatter="item.isFormat ? formatColumn : null"
              :sortable="item.isSort ? 'custom': null"
              :fixed="item.isLock ? 'right' : null"
              show-overflow-tooltip
            >
          </el-table-column>
          <template v-if="cleanColumn.length">
              <el-table-column v-for="(mtem, mndex) in monthArr" :label="mtem" :key="mtem" align="center">
                <template v-for="(item, index) in cleanColumn">
                  <el-table-column
                    v-if="item.selected && item.columnCode !== 'cleanArea'&& item.columnCode !== 'usageTime'"
                    :key="index"
                    :index="index"
                    :prop="`${item.columnCode}${mndex+1}`"
                    :label="item.columnName"
                    :width="item.width"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    v-if="item.selected && item.columnCode === 'cleanArea'"
                    :key="index"
                    :index="index"
                    :prop="`${item.columnCode}${mndex+1}`"
                    :label="`${item.columnName}(${$formatLenUnit()})`"
                    :width="item.width"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{scope.row[`${item.columnCode}${mndex+1}`]>0?$numCommaSplit($formatLenLocal(scope.row[`${item.columnCode}${mndex+1}`])):scope.row[`${item.columnCode}${mndex+1}`]}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="item.selected && item.columnCode === 'usageTime'"
                    :key="index"
                    :index="index"
                    :prop="`${item.columnCode}${mndex+1}`"
                    :label="item.columnName"
                    :width="item.width"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{scope.row[`${item.columnCode}${mndex+1}`]>0?$formatSecToHh(scope.row[`${item.columnCode}${mndex+1}`]):scope.row[`${item.columnCode}${mndex+1}`]}}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table-column>
          </template>
          <!-- 占位列 -->
            <el-table-column v-if="!tableColumn.length"></el-table-column>
        </el-table>

      </div>
      <div class="table-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
  </div>

  <!-- </div> -->
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';

// us_list_gsmc: 公司名称// us_list_xmqymc: 项目/区域名称// us_list_suo_shu_bu_men: 所属部门// us_list_shai_xuan_xiang: 筛选项// us_list_kai_shi_yue: 开始月// us_list_jie_shu_yue: 结束月

export default {
  name: 'usagemonth-site-list',
  props: {

  },
  components: {},
  computed: {
    monthArr() {
      const endDate = this.reportMonthTime ? this.reportMonthTime[1] : '';
      // 最近4个月
      if (endDate) {
        return [this.$moment(endDate).format('YYYYMM'), this.$moment(endDate).subtract(1, 'months').format('YYYYMM'), this.$moment(endDate).subtract(2, 'months').format('YYYYMM'), this.$moment(endDate).subtract(3, 'months').format('YYYYMM')];
      }
      return [];
    }
  },
  data() {
    return {
      tableCode: 'usage_month',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        bodyNum: '',
        startTime: '',
        endTime: '',
        customerName: '',
        search: '',
        showSubsidiary: '',
        ym: '',
        departmentId: '',
        departmentName: ''
      },
      tableColumn: [],
      cleanColumn: [],
      totalRows: null,
      tableList: [],
      isFilter: false,
      choiceDate: null,
      reportMonthTime: [`${moment(this.$getLocalTime()).subtract(3, 'months').format('YYYY-MM')}`, `${moment(this.$getLocalTime()).format('YYYY-MM')}`],
      pickerOptionsMonth: {
        firstDayOfWeek: 1,
        // 范围选最近4个月
        disabledDate: time => (this.choiceDate ? !moment(time).isSame(moment(this.choiceDate).subtract(3, 'months'), 'months') && !moment(time).isSame(moment(this.choiceDate).add(3, 'months'), 'months') || moment(time).isAfter(this.$getLocalTime(), 'day') : moment(time).isAfter(this.$getLocalTime(), 'day')),
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime();
          if (maxDate) {
            this.choiceDate = '';
          }
        },
      },
    };
  },
  watch: {

  },
  // created() {

  // },
  mounted() {
    this.mergeLanguage(null, 'portal_usagemonth_site_list');
    this.getReportPage();
  },
  methods: {
    i18nCallback() {
      this.getFuncView(null, () => {
        this.getTableColumn();
      });
    },
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }

        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },
    onDepartmentLabel(Label) {
      this.formSearch.departmentName = Label;
    },
    // 月 周 table
    getReportPage: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.formSearch.ym = this.reportMonthTime ? this.reportMonthTime[1] : '';
      this.$getJSON(apis.portalSiteMonthPage, { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 获取表格列
    getTableColumn: function () {
      this.$getJSON(apis.TableColumnGet, { tableCode: 'usage_month' }).then((res) => {
        const list = res.data;
        // 数组切两段 （平均清洁得分 清洁面积ft² 清洁时长 小时 清洁天数）
        const splitNumber = list.findIndex(i => i.columnCode === 'meetGoalCount');
        this.tableColumn = list.slice(0, splitNumber).filter(t => t.columnCode !== 'bodyNum');
        if (!this.isCoJv) {
          this.tableColumn = this.tableColumn.filter(t => t.columnCode !== 'customerName');
        }
        // 权限
        // 区域 - 达标次数  usagemonth_site_meetGoal
        // 区域 - 清洁得分  usagemonth_site_cleanScore
        // 区域 - 清洁面积  usagemonth_site_cleanArea
        // 区域 - 清洁时长  usagemonth_site_cleanTime
        // 区域 - 清洁天数  usagemonth_site_cleanDay


        // 表格列
        // +机身号 bodyNum
        //          202401
        //          202312
        //          202311
        //          202310
        // -达标次数 meetGoalCount
        // -平均清洁得分 cleanScoreAvg
        // 清洁面积ft²  cleanArea
        // 清洁时长小时 usageTime
        // 清洁天数 cleanDays
        // this.funcView.usagemonth_site_meetGoal&&  i.columnCode !== 'meetGoalCount'
        // this.funcView.usagemonth_site_cleanScore&&  i.columnCode !== 'cleanScoreAvg'
        // this.funcView.usagemonth_site_cleanArea&&  i.columnCode !== 'cleanArea'
        // this.funcView.usagemonth_site_cleanTime&&  i.columnCode !== 'usageTime'
        // this.funcView.usagemonth_site_cleanDay&&  i.columnCode !== 'cleanDays'

        this.cleanColumn = list.slice(splitNumber).filter(item => !((item.columnCode === 'meetGoalCount' && !this.funcView.usagemonth_site_meetGoal)
          || (item.columnCode === 'cleanScoreAvg' && !this.funcView.usagemonth_site_cleanScore)
          || (item.columnCode === 'cleanArea' && !this.funcView.usagemonth_site_cleanArea)
          || (item.columnCode === 'usageTime' && !this.funcView.usagemonth_site_cleanTime)
          || (item.columnCode === 'cleanDays' && !this.funcView.usagemonth_site_cleanDay))
        );

      });
    },
    // 清空标签
    onClear() {
      this.formSearch.customerName = '';
      this.formSearch.search = '';
      this.formSearch.departmentId = '';
      this.formSearch.departmentName = '';
      this.onPageChange({ page: 1 });
    },

    // 导出数据
    exportRecord: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$exportFlie(apis.portalSiteMonthExport, { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' }).then(() => { });
    },
    refreshPage() {
      this.getReportPage();
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getReportPage();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.usagemonth-site-list {
  .el-tabs .el-tabs__item {
    font-size: 14px;
  }

  .table-list {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 24px 0;
    .header {
      // padding: 24px;
      .label {
        color: #1a1a1a;
        line-height: 40px;
        font-weight: bold;
        float: left;
      }

      .search-content {
        float: right;
      }

      .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 16px;
        width: 40px;
        height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
    }
    .table-bd {
      background: #ffffff;
      border-radius: 16px;
      padding: 24px 24px 0;
      margin-top: 24px;
      height:600px;
      .el-table--border th, .el-table--border td{
        border-right: 1px solid #EBEEF5 !important;
      }
    }
  }
}
</style>
